import React from "react";

// Geometric spider web icon — concentric hexagonal web with radial spokes.
export const WebIcon = ({ className = "", stroke = "currentColor" }) => {
  const cx = 32;
  const cy = 32;
  const rings = [8, 15, 22, 28];
  // 6 radial points (hexagon orientation)
  const angles = [-90, -30, 30, 90, 150, 210];
  const pt = (r, a) => {
    const rad = (a * Math.PI) / 180;
    return [cx + r * Math.cos(rad), cy + r * Math.sin(rad)];
  };
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      fill="none"
      stroke={stroke}
      strokeWidth="1.7"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      {/* radial spokes */}
      {angles.map((a, i) => {
        const [x, y] = pt(28, a);
        return <line key={`s-${i}`} x1={cx} y1={cy} x2={x} y2={y} />;
      })}
      {/* concentric web rings */}
      {rings.map((r, ri) => {
        const points = angles.map((a) => pt(r, a).join(",")).join(" ");
        return <polygon key={`r-${ri}`} points={points} />;
      })}
      <circle cx={cx} cy={cy} r="1.6" fill={stroke} stroke="none" />
    </svg>
  );
};

// Full lockup: icon + wordmark
export const Logo = ({ dark = false, className = "", iconSize = "w-12 h-12" }) => {
  const textColor = dark ? "text-white" : "text-charcoal";
  const iconStroke = dark ? "#ffffff" : "#1a1a1a";
  return (
    <div className={`flex items-center gap-3.5 ${className}`} data-testid="brand-logo">
      <WebIcon className={iconSize} stroke={iconStroke} />
      <div className="flex flex-col leading-none">
        <span className={`font-serif text-3xl leading-none ${textColor}`}>Elevated</span>
        <span
          className="font-display text-[0.8rem] font-semibold tracking-[0.5em] text-sky-brand"
          style={{ marginLeft: "1px" }}
        >
          WEB
        </span>
      </div>
    </div>
  );
};

export default Logo;
